import ScreenSizePage from './ScreenSizePage';
export default ScreenSizePage;
